module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("固件包管理")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-form', {
    attrs: {
      "inline": "",
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "更新包类型"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.clickQuery
    },
    model: {
      value: (_vm.queryForm.deviceType),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "deviceType", $$v)
      },
      expression: "queryForm.deviceType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "一体机安装包(1代)",
      "value": "一体机"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "一体机安装包(2代)",
      "value": "二代一体机"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IPC",
      "value": "IPC"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "主控",
      "value": "主控"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "主屏幕固件包(1代)",
      "value": "主屏幕"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "主屏幕固件包(2代)",
      "value": "二代主屏幕"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "超脑",
      "value": "超脑"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "算力盒子",
      "value": "算力盒子"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "坐位体前屈软件安装包",
      "value": "坐位体前屈"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "坐位体前屈屏幕固件包",
      "value": "坐位体前屈固件包"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "LED大屏安装包",
      "value": "LED信息盒软件"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "智慧体育盒子安装包",
      "value": "高校体育盒子软件"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickQuery
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickAddition
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.listData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "80",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "类型",
      "prop": "deviceType"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "版本号",
      "prop": "versionCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "上传时间",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(_vm.handleDate(row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序列号",
      "prop": "versionSeq"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "备注",
      "prop": "content"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.clickEdit(row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.clickDelete(row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalCount > 0),
      expression: "totalCount > 0"
    }],
    attrs: {
      "layout": "prev, pager, next, jumper",
      "current-page": _vm.queryForm.pageNum,
      "page-size": _vm.queryForm.pageSize,
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.updateDialog.form.id ? '编辑版本' : '添加版本',
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "destroy-on-close": ""
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.updateDialog.visible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickDone
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.updateDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.updateDialog, "visible", $$v)
      },
      expression: "updateDialog.visible"
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "formRef",
    attrs: {
      "model": _vm.updateDialog.form,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "平台",
      "prop": "deviceType"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeDeviceType
    },
    model: {
      value: (_vm.updateDialog.form.deviceType),
      callback: function($$v) {
        _vm.$set(_vm.updateDialog.form, "deviceType", $$v)
      },
      expression: "updateDialog.form.deviceType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "一体机"
    }
  }, [_vm._v("一体机安装包(1代)")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "二代一体机"
    }
  }, [_vm._v("一体机安装包(2代)")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "IPC"
    }
  }, [_vm._v("IPC")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "主控"
    }
  }, [_vm._v("主控")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "主屏幕"
    }
  }, [_vm._v("主屏幕固件包(1代)")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "二代主屏幕"
    }
  }, [_vm._v("主屏幕固件包(2代)")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "超脑"
    }
  }, [_vm._v("超脑")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "算力盒子"
    }
  }, [_vm._v("算力盒子")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "坐位体前屈"
    }
  }, [_vm._v("坐位体前屈软件安装包")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "坐位体前屈固件包"
    }
  }, [_vm._v("坐位体前屈屏幕固件包")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "LED信息盒软件"
    }
  }, [_vm._v("LED大屏安装包")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "高校体育盒子软件"
    }
  }, [_vm._v("智慧体育盒子安装包")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "AI体锻小站软件"
    }
  }, [_vm._v("AI体锻小站安装包")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "版本号",
      "prop": "versionCode"
    }
  }, [_c('el-input', {
    ref: "codeRef",
    attrs: {
      "placeholder": "版本号格式为X.X.X",
      "clearable": ""
    },
    model: {
      value: (_vm.updateDialog.form.versionCode),
      callback: function($$v) {
        _vm.$set(_vm.updateDialog.form, "versionCode", $$v)
      },
      expression: "updateDialog.form.versionCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "android-update",
    attrs: {
      "label": "应用包"
    }
  }, [_c('div', {
    staticClass: "flex width-100"
  }, [_c('el-upload', {
    ref: "uploadRef",
    staticClass: "flex-sub flex",
    attrs: {
      "action": "#########",
      "limit": 1,
      "accept": _vm.upload.fileAccept,
      "on-exceed": _vm.handleExceed,
      "http-request": _vm.uploadFile,
      "file-list": _vm.upload.fileList
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function() {
        return [_c('el-button', {
          staticStyle: {
            "margin-right": "8px"
          },
          attrs: {
            "type": "primary",
            "disabled": _vm.upload.disabled
          }
        }, [_vm._v("文件上传")])]
      },
      proxy: true
    }])
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "序列号",
      "prop": "versionSeq"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "序列号",
      "clearable": ""
    },
    model: {
      value: (_vm.updateDialog.form.versionSeq),
      callback: function($$v) {
        _vm.$set(_vm.updateDialog.form, "versionSeq", $$v)
      },
      expression: "updateDialog.form.versionSeq"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更新描述"
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 4,
      "type": "textarea",
      "placeholder": "请输入内容",
      "maxlength": 200,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.updateDialog.form.content),
      callback: function($$v) {
        _vm.$set(_vm.updateDialog.form, "content", $$v)
      },
      expression: "updateDialog.form.content"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8345fb12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/EquipmentManage/FirmwareManage/FirmwareManage.vue
// module id = 1096
// module chunks = 0